/**
 * File that can be loaded in each page as a mixin, handles data table js code
 */
const HDN_INDEX_NAME = "HDN Index";
export const consentPopUpMixin = {
    created() {
        this.HDN_INDEX_NAME = HDN_INDEX_NAME;
    },
    methods: {
        hasConsentRequiredFunctionalityAuthorization(functionalityAutorizations) {

            for (let functionalityAutorization of functionalityAutorizations) {
                let name = functionalityAutorization?.StaticFunctionalityMember?.StaticFunctionality?.StaticApplication?.name;

                let disabled = functionalityAutorization?.VersionFunctionalityMemberUserGroup?.[0]?.isDisabled;
                let requestToBeActive = functionalityAutorization.VersionFunctionalityMemberUserGroupRequested?.[0]?.isDisabled === false;

                if (name === HDN_INDEX_NAME && (!disabled || requestToBeActive)) {
                    return true;
                }
            }
            return false;
        },
        hasConsentRequiredFunctionalityMemberUserGroup(dataTableItem) {
            let applicationName = dataTableItem?.applicationName;
            let disabled = dataTableItem?.requested?.isDisabled;
            if(applicationName === HDN_INDEX_NAME && disabled !== true) {
                return true;
            }

            return false;
        }
    }
}